export default {
  "brand": "USFansLink",
  "brandSub": "Centro de recursos de la hoja",
  "nav.home": "Inicio",
  "nav.guides": "Guías de compra",
  "nav.guide": "Guía para principiantes",
  "nav.review": "Reseña de USFans",
  "nav.shipping": "Costo de envío",
  "nav.qc": "Guía de QC",
  "nav.coupon": "Guía de cupones",
  "nav.warehouse": "Guía del almacén",
  "nav.legit": "¿Es legítimo USFans?",
  "buyNow": "Comprar ahora",
  "exploreSpreadsheet": "Explora la hoja de USFans",
  "readGuide": "Lee la guía para principiantes",
  "language": "Idioma",
  "backHome": "Volver al inicio",
  "mainSite": "Visitar el sitio principal",
  "footer.disclaimer": "USFansLink.fun es un recurso informativo independiente. No es el sitio web oficial de USFans y no garantiza vendedores, productos, precios, servicios de envío ni resultados de transacciones. Verifica siempre la información actual antes de comprar.",
  "footer.rights": "Todos los derechos reservados.",
  "footer.independent": "Recurso independiente",
  "footer.updated": "Guías actualizadas",
  "footer.multilingual": "Soporte multilingüe",
};